import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { LandingService } from '@commoncore/services/landing.service';
import { ENV_CONSTANTS, environment } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'lib-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['../landing/landing.component.scss'],
  imports:[DependenciesModule]
})
export class LandingFooterComponent implements OnInit {
  androidDownloadURL = ENV_CONFIG["appDownloadUrls"]["mobileClient"]["playStore"];
  iosDownloadURL = ENV_CONFIG["appDownloadUrls"]["mobileClient"]["appStore"];
  macDownloadURL = ENV_CONFIG["appDownloadUrls"]["macClient"][environment.name];
  windowsDownloadURL = ENV_CONFIG["appDownloadUrls"]["windowsClient"][environment.name];
  jtrUrl: any;
  constructor(public landingService: LandingService,public router: Router,) { }

  ngOnInit(): void {
    this.jtrUrl = ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME]["jtrUrl"];
    setTimeout(()=>{
      window.scrollTo(0, 0);
    },200)
  }

  loadFaqPage() {
    var faqLink = '/help';
    window.open(faqLink, "_blank", "noopener, noreferrer");
  }

  toggleAccordion(event){
    if(!event.target.getAttribute("data-toggle")) return;
    let allDivs = event.currentTarget.childNodes;
    let parentEL = event.target.parentNode.parentNode as HTMLElement;
    allDivs.forEach(element => {
      let div = element.childNodes[0] as HTMLElement;
      if(element.id == parentEL.id){
        if(div.classList.contains("border-0")){
          div.classList.remove("border-0");
        }
        else {
          div.classList.add("border-0");
        }
      }
      else{
        if(div.classList.contains("border-0")){
          div.classList.remove("border-0");
        }
      }
    });
  }

  redirectToLink(link){
    let url = '';
    if(link == 'jiocloud'){
      url = "/"
    }else if( link == 'jtr'){
      url = ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME]["jtrUrl"];
    }else if (link == 'faq'){
      url = '/help/home'
    }else if (link == 'howto'){
      url = '/how-to-videos/faq'
    }
    window.open(url,"_blank", "noopener, noreferrer");
  }
}
